<div class="page-layout">
    <div class="voicemail-greeting">
    <h1 class="voicemail-config">Voicemail Greeting</h1>
    <span>
    <h2>Current user profile:</h2>
    <h2>{{agentName}}</h2>
    </span>
    <div [hidden]="invalidEmail == false">Invalid Email Format</div>
    <div [hidden]="loadingAgent == false">Searching for Agent</div> 
    <div [hidden]="invalidUser == false">User does not exist</div> 
    <!-- <form [formGroup]="AgentForm"> -->
        <!-- <div class="form-group" [class.has-error]="agentUsername.invalid && agentUsername.touched"> -->
            <!-- <input id="email" required name="email" [(ngModel)]="userProfile" type="email" class="form-control" formControlName="email" placeholder="Enter Agent Username"/> -->
            <input [(ngModel)]="userProfile" (change)="agentEmailValidation(userProfile)">
            <!-- <button class="save-btn" (click)="voicemailProfileSearch()" mat-button>Search</button> -->
            <!-- <div class="error" *ngif="agentUsername.invalid && agentUsername.touched">Username required</div>  -->
        <!-- </div> -->
    <!-- </form> -->
    
    
    
    <!-- Data grid main  -->
    <section class="voicemail-main" [hidden]='!(state ==="main")'>
            <section class="datagrid" >
                <app-vm-data-grid
                        class="page-data-grid"
                        [formValid]="formValid"
                        [(dataSource)]="data"
                        [searchBarEnabled]="false"
                        [displayedColumns]="[ 'type', 'description', 'content', 'status', 'greetingId' ]"
                        [columnNames]="[ 'Type', 'Name', 'Preview', 'Status']"
                        [displayDefinition]="{
                            'type':typeTemplate,
                            'greetingId':selectTemplate,
                            'status':statusTemplate,
                            'content':previewTemplate
    
                        }"
                        [pageSizeOptions]="[5, 10, 25, 50]"
                        [showButtons]="false"
                        [buttonConfig]="{
                            delete: {show: false},
                            edit: { show: false },
                            create: { show: false }
                        }"
                        [objectBluePrint]="bluePrint"
    
                    >
                    <ng-template let-element #typeTemplate >
                        <div *ngIf="element.type === 'tts'">text to speech</div>
                        <div *ngIf="element.type === 'audio'">audio</div>
                    </ng-template>
    
                    <ng-template let-element #selectTemplate >
                        <button class="select-btn" (click)="selectedGreeting(element.greetingId);" mat-button>Select</button>
                    </ng-template>
    
                    <ng-template let-element #previewTemplate let-column="_column">
                        <mat-icon class="preview-play" *ngIf="isplaying === false"  (click)="selectedGreetingPreview(element.greetingId);" mat-button>play_arrow</mat-icon>
                        <mat-icon class="preview-play" *ngIf="isplaying === true"  (click)="stopPreview();" mat-button>stop</mat-icon>
                    </ng-template>
    
                    <ng-template let-element #statusTemplate>
                        <div class="enable-status" [hidden]="!(element.greetingId === enabledGreeting)">Enabled</div>
                        <div class="disable-status" [hidden]="(element.greetingId === enabledGreeting)">Disabled</div>
                    </ng-template>
                    </app-vm-data-grid>
            </section>
            <section class="create-new-section">
                <div class="create-new-title" >Create New</div>
                <div class="create-new-section-btns">
                    <button class="create-new-btns" mat-button (click)="displayVoicemailPage('recording'); clearForms()">Audio Recording</button>
                    <button class="create-new-btns" (click)="displayVoicemailPage('tts'); clearForms()" mat-button>Text to Speech</button>
                </div>
                <div class="voicemail-delegation">
                    <h3>Voicemail Delegation</h3>
                </div>
                <div>
                   <!-- <h4>CC Voicemail Transcript</h4>  -->
                   <h4 class="invalid" [hidden]="cctranscriptValid === true">Invalid Email</h4>
                   <h4 class="ccsaved" [hidden]="ccSaved === false">CC Saved</h4>
                </div>
                
                <div>
                    <textarea class="transcript" type="text" placeholder="Type your manager's email address in box below." [(ngModel)]="cctranscript"></textarea>
                </div>
                <div>
                    <button class="save-btn" mat-button (click)="voicemailDelegation()">Save</button>
                </div>
            </section>
    </section>
    <!-- TTS create/select  -->
    <section class="tts-main" *ngIf='(state ==="tts")'>
        <mat-icon class="back-arrow" (click)="displayVoicemailPage('main'); clearForms();  getGreeting(); getUserEnabled()" >arrow_back</mat-icon>
        <div class="tts" >
            <h4 class="voicemaildisabled" [hidden]="VMDisabled === false">Voicemail Disabled</h4>
            <h4 class="voicemailenabled" [hidden]="VMEnabled === false">Voicemail Enabled</h4>
            <h4 class="voicemailsaved" [hidden]="VMSaved === false">Voicemail Saved</h4>
        <div class="current-greeting">Test Text to Speech {{description}} </div>
        
        <input class="description" id="name" [(ngModel)]="tempDescription" type="text" placeholder="Name" [disabled]="greetingId === 'default'" value="{{description}}" >
    <textarea class="text-area" id="content" [(ngModel)]="tempContent" type="text" placeholder="Voicemail Text" [disabled]="greetingId === 'default'" value="{{content}}"></textarea>
        
        <div class="creat-new-section">
            <button class="save-btn" mat-button (click)="saveRecordingTTS()" [disabled]="(greetingId === 'default')">Save</button>
            <button class="cancel-btn" mat-button (click)="displayVoicemailPage('main'); getGreeting();" [disabled]="textVoicemailSaved === true || (greetingId === 'default')">Cancel</button>
            <button class="delete-btn" (click)="displayVoicemailPage('main'); deleteGreeting(); getGreeting();" [disabled]="newGreeting === true || (greetingId === 'default')" mat-button>Delete</button>
        </div>
        <div class="bottom-row-btns">
            <button class="disable-btn" *ngIf="(greetingId === enabledGreeting) && !(greetingId === 'default')" (click)="greetingDisabled()" [disabled]="newGreeting === true">Disable</button>
            <button class="enable-btn" *ngIf='!(greetingId === enabledGreeting)' (click)="greetingEnabled()" [disabled]="newGreeting === true" mat-button>Enable</button>
            <button class="cancel-btn" mat-button (click)="playPreviewTTS(tempContent)" [disabled]="tempContent === ''">Preview</button>
        </div>
    </div>
    </section>
    <!-- Recording Voicemail  -->
    <section class="recording-voicemail-main" [hidden]='!(state ==="recording")'>
        <mat-icon class="back-arrow" (click)="displayVoicemailPage('main'); clearForms(); getGreeting(); getUserEnabled()" >arrow_back</mat-icon>
        <div class="recording-voicemail">
            <h4 class="voicemaildisabled" [hidden]="VMDisabled === false">Voicemail Disabled</h4>
            <h4 class="voicemailenabled" [hidden]="VMEnabled === false">Voicemail Enabled</h4>
            <h4 class="voicemailsaved" [hidden]="VMSaved === false">Voicemail Saved</h4>
        <div class="current-greeting">Current Greeting {{description}} </div>
      
    <input  id="audioName" class="description" [(ngModel)]="tempAudioDescription" type="text" placeholder="Name" value="{{description}}" maxlength="500">
    
    <div>
        <span> 
    <audio id="audio-layer" controls="">
        <source id="audio-source" src="" type="audio/wav">
    </audio>
    <mat-icon [hidden]="!(recordingPresentLocal)" (click)="deleteLocalRecording()"><i class="material-icons nav-icons" id="trashcan">delete</i></mat-icon>
    </span>
    </div>
    <div class="creat-new-section">
        <button class="start-recording-btn" mat-button *ngIf='recordingStatus ==="not recording"' (click)="initiateRecording()">Start Recording</button>
        <button class="stop-recording-btn" mat-button *ngIf='recordingStatus ==="recording"' (click)="stopRecording()">{{timerDate}}</button>
        <button class="save-btn" mat-button [disabled]='(audioPlayer === null)' (click)="saveLocalRecording()">Save</button>
    </div>
    <div class="bottom-row-btns">
        <button class="disable-btn" [disabled]="newGreeting === true" *ngIf="(greetingId === enabledGreeting)" (click)="greetingDisabled()"mat-button>Disable</button>
        <button class="enable-btn" [disabled]="newGreeting === true" *ngIf="!(greetingId === enabledGreeting)" (click)="greetingEnabled()" mat-button>Enable</button>
        <button class="delete-btn" (click)="deleteRecording(); deleteGreeting()" [disabled]="newGreeting === true" mat-button>Delete</button>
    </div>
    </div>
    </section>
    </div>
    </div>